import { render, staticRenderFns } from "./NotificationsDocumentsList.vue?vue&type=template&id=00df5504&scoped=true&"
import script from "./NotificationsDocumentsList.vue?vue&type=script&lang=ts&"
export * from "./NotificationsDocumentsList.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsDocumentsList.vue?vue&type=style&index=0&id=00df5504&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00df5504",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
